import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import shareArticle from "@tIntermatic/Handlers/INTShareArticle";
import { ShareArticleParameter } from "@tIntermatic/Services/INTShareArticleService";

import translate from "@insite/client-framework/Translate";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import toast from "@insite/mobius/Toast";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
// const ToastText = require('./Toast').ToastText;

import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Share from "@tIntermatic/Icons/Share";
import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    text?: string;
    article: ShareArticleParameter;
    extendedStyles?: INTArticleShareLinkStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

const mapDispatchToProps = {
    shareArticle,
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: React.RefObject<ReCAPTCHA> },
        boolean
    >(validateReCaptcha),
};

export interface INTArticleShareLinkStyles {
    link?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    recipientNameGridItem?: GridItemProps;
    recipientNameTextField?: TextFieldProps;
    recipientEmailGridItem?: GridItemProps;
    recipientEmailTextField?: TextFieldProps;
    yourNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldProps;
    yourEmailGridItem?: GridItemProps;
    yourEmailTextField?: TextFieldProps;
    yourMessageGridItem?: GridItemProps;
    yourMessageTextArea?: TextAreaProps;
    cancelButton?: ButtonPresentationProps;
    shareButton?: ButtonPresentationProps;
    buttonWrapper?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
}

export const articleShareLinkStyles: INTArticleShareLinkStyles = {
    modal: {
        size: 650,
        cssOverrides: {
            scrim: css`
                height: 100% !important;
                overflow: auto;
                position: absolute !important;
                touch-action: auto;
            `,
            modalContainer: css`
                > div {
                    height: auto;
                }
            `,
            modalTitle: css`
                background-color: #33333a;
                color: #ffffff;
                height: 77px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 10px 23px 10px 45px;
                        `,
                        css`
                            padding: 10px 23px 10px 45px;
                        `,
                        css`
                            padding: 10px 23px 10px 40px;
                        `,
                        css`
                            padding: 10px 23px 10px 40px;
                        `,
                        css`
                            padding: 10px 23px 10px 40px;
                        `,
                    ])}
                h4[class^="TypographyStyle"] {
                    font-size: 30px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 30px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                color: #ffffff;
                                font-size: 26px;
                                font-weight: 600;
                                letter-spacing: 0;
                                line-height: 30px;
                            `,
                            css`
                                color: #ffffff;
                                font-size: 26px;
                                font-weight: 600;
                                letter-spacing: 0;
                                line-height: 30px;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
            modalContent: css`
                padding: 20px 37px 30px 24px;
            `,
            modalBody: css`
                box-shadow: 0 0 10px 0 rgb(0 0 0 / 0.15) !important;
                background-color: #fff;
                position: absolute;
                top: 290px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                top: 1%;
                                margin: 0 auto;
                                min-width: 90% !important;
                                width: 90% !important;
                            `,
                            css`
                                top: 1%;
                                margin: 0 auto;
                                min-width: 90% !important;
                                width: 90% !important;
                            `,
                            css`
                                top: 1%;
                                margin: 0 auto;
                                min-width: 90% !important;
                                width: 90% !important;
                            `,
                            css`
                                top: 290px;
                                min-width: auto !important;
                                width: auto !important;
                            `,
                            css`
                                top: 290px;
                                min-width: auto !important;
                                width: auto !important;
                            `,
                        ],
                        "min",
                    )}
            `,
            titleButton: css`
                background-color: #33333a;
                border: none;
                padding: 0;
                span[class^="IconWrapper"] {
                    color: #fff !important;
                    height: 35px;
                    width: 35px;
                    > svg {
                        height: 35px;
                        width: 35px;
                        stroke-width: 1.5;
                    }
                }
                &:hover {
                    background: none;
                }
            `,
        },
    },
    container: { gap: 10 },
    recipientNameGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-right: 10px;
            margin-bottom: 28px !important;
            padding: 5px 20.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 24.5px;
                    `,
                    css`
                        padding: 5px 24.5px;
                        margin-bottom: 18px !important;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                ])}
            label[class^="TypographyStyle"] {
                color: #33333a;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 0;
                line-height: 22px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="DescriptionWrapper"] {
                margin-top: 3px !important;
                position: absolute;
                > span {
                    font-size: 13px;
                    letter-spacing: 0;
                    line-height: 16px;
                    color: #760303;
                    font-weight: normal;
                }
            }
        `,
    },
    reCaptchaGridItem: {
        width: 12,
    },
    recipientNameTextField: {
        css: css`
            height: 47px !important;
            border: 1px solid #cccccc !important;
        `,
    },
    recipientEmailGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-left: 10px;
            margin-bottom: 28px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 24.5px;
                    `,
                    css`
                        padding: 5px 24.5px;
                        margin-bottom: 18px !important;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                ])}
            label[class^="TypographyStyle"] {
                color: #333333;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 0;
                line-height: 22px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="DescriptionWrapper"] {
                margin-top: 3px !important;
                position: absolute;
                > span {
                    font-size: 13px;
                    letter-spacing: 0;
                    line-height: 16px;
                    color: #760303;
                    font-weight: normal;
                }
            }
        `,
    },
    recipientEmailTextField: {
        css: css`
            height: 47px !important;
            border: 1px solid #cccccc !important;
        `,
    },
    yourNameGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-right: 10px;
            margin-bottom: 28px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 24.5px;
                    `,
                    css`
                        padding: 5px 24.5px;
                        margin-bottom: 18px !important;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                ])}
            label[class^="TypographyStyle"] {
                color: #333333;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 0;
                line-height: 22px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="DescriptionWrapper"] {
                margin-top: 3px !important;
                position: absolute;
                > span {
                    font-size: 13px;
                    letter-spacing: 0;
                    line-height: 16px;
                    color: #760303;
                    font-weight: normal;
                }
            }
        `,
    },
    yourNameTextField: {
        css: css`
            height: 47px !important;
            border: 1px solid #cccccc !important;
        `,
    },
    yourEmailGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-left: 10px;
            margin-bottom: 28px !important;
            padding: 5px 20.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 24.5px;
                    `,
                    css`
                        padding: 5px 24.5px;
                        margin-bottom: 18px !important;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                ])}
            label[class^="TypographyStyle"] {
                color: #333333;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 0;
                line-height: 22px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="DescriptionWrapper"] {
                margin-top: 3px !important;
                position: absolute;
                > span {
                    font-size: 13px;
                    letter-spacing: 0;
                    line-height: 16px;
                    color: #760303;
                    font-weight: normal;
                }
            }
        `,
    },
    yourEmailTextField: {
        css: css`
            height: 47px !important;
            border: 1px solid #cccccc !important;
        `,
    },
    yourMessageGridItem: {
        width: 12,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 24.5px;
                    `,
                    css`
                        padding: 5px 24.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                    css`
                        padding: 5px 20.5px;
                    `,
                ])}
            label[class^="TypographyStyle"] {
                color: #333333;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 0;
                line-height: 22px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        css`
                            color: #33333a;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 24px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="DescriptionWrapper"] {
                margin-top: -3px !important;
                position: absolute;
                > span {
                    font-size: 13px;
                    letter-spacing: 0;
                    line-height: 16px;
                    color: #760303;
                    font-weight: normal;
                }
                > span {
                    font-size: 13px;
                    letter-spacing: 0;
                    line-height: 16px;
                    color: #760303;
                    font-weight: normal;
                }
            }
        `,
    },

    yourMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                resize: none;
                height: 142px;
                border: 1px solid #cccccc !important;
            `,
        },
    },

    buttonWrapper: {
        width: 12,
        css: css`
            display: flex;
            margin-top: 33px !important;
            justify-content: center;
            > div {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                            padding: 5px 24.5px;
                        `,
                        css`
                            width: 100%;
                            padding: 5px 24.5px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    shareButton: {
        css: css`
            height: 40px;
            width: 247px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
            > span {
                color: #ffffff;
                font-size: 12px;
                font-weight: bold;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
            }
        `,
    },

    link: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 10px;
                    `,
                    css`
                        padding-right: 10px;
                    `,
                    null,
                    null,
                    null,
                ])}
            > span {
                display: flex;
                align-items: center;
                color: #33333a !important;
                text-transform: uppercase;
                font-size: 15px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 14px;
            }
        `,
    },
};

const INTArticleShareLink = ({ article, text, session, shareArticle, validateReCaptcha, extendedStyles }: Props) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = React.useState(() => mergeToNew(articleShareLinkStyles, extendedStyles));
    const isAuthenticated = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [recipientName, setRecipientName] = React.useState("");
    const [recipientNameError, setRecipientNameError] = React.useState("");
    const [recipientEmail, setRecipientEmail] = React.useState("");
    const [recipientEmailError, setRecipientEmailError] = React.useState("");
    const initialYourName = isAuthenticated
        ? `${session!.firstName} ${session!.lastName}`.trim() || session!.userName || ""
        : "";
    const [yourName, setYourName] = React.useState(initialYourName);
    const [yourNameError, setYourNameError] = React.useState("");
    const initialYourEmail = isAuthenticated ? session.email || "" : "";
    const [yourEmail, setYourEmail] = React.useState(initialYourEmail);
    const [yourEmailError, setYourEmailError] = React.useState("");
    const [yourMessage, setYourMessage] = React.useState("");
    const [yourMessageError, setYourMessageError] = React.useState("");
    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const shareLinkClickHandler = () => {
        resetFields();
        setModalIsOpen(true);
    };

    const requiredFieldMessage = translate("This is a required field");
    const emailFieldMessage = translate("Enter a valid email address");
    const nameCountError = translate("Maximum character limit is 30");
    const messageCountError = translate("Maximum character limit is 500");
    const checkForErrors = () => {
        const regexp = new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        const nameCount = 30;
        const messageCount = 500;
        const localRecipientNameError = !recipientName
            ? requiredFieldMessage
            : recipientName.length > nameCount
            ? nameCountError
            : "";
        setRecipientNameError(localRecipientNameError);
        const localRecipientEmailError = !recipientEmail
            ? requiredFieldMessage
            : regexp.test(recipientEmail)
            ? ""
            : emailFieldMessage;
        setRecipientEmailError(localRecipientEmailError);
        const localYourNameError = !yourName ? requiredFieldMessage : yourName.length > nameCount ? nameCountError : "";
        setYourNameError(localYourNameError);
        const localYourEmailError = !yourEmail ? requiredFieldMessage : regexp.test(yourEmail) ? "" : emailFieldMessage;
        setYourEmailError(localYourEmailError);
        const localYourMessageError = !yourMessage
            ? requiredFieldMessage
            : yourMessage.length > messageCount
            ? messageCountError
            : "";
        setYourMessageError(localYourMessageError);

        return !!(
            localRecipientNameError ||
            localRecipientEmailError ||
            localYourNameError ||
            localYourEmailError ||
            localYourMessageError
        );
    };

    const resetFields = () => {
        setRecipientName("");
        setRecipientNameError("");
        setRecipientEmail("");
        setRecipientEmailError("");
        setYourName(initialYourName);
        setYourNameError("");
        setYourEmail(initialYourEmail);
        setYourEmailError("");
        setYourMessage("");
        setYourMessageError("");
    };

    const recipientNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRecipientName(event.target.value);
        setRecipientNameError(!event.target.value ? requiredFieldMessage : "");
    };
    const recipientEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRecipientEmail(event.target.value);
        setRecipientEmailError(!event.target.value ? requiredFieldMessage : "");
    };
    const yourNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setYourName(event.target.value);
        setYourNameError(!event.target.value ? requiredFieldMessage : "");
    };
    const yourEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setYourEmail(event.target.value);
        setYourEmailError(!event.target.value ? requiredFieldMessage : "");
    };
    const yourMessageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setYourMessage(event.target.value);
        setYourMessageError(!event.target.value ? requiredFieldMessage : "");
    };

    const shareButtonClickHandler = async () => {
        if (checkForErrors()) {
            return;
        }
        const isReCaptchaValid = await validateReCaptcha({
            location: "ShareProduct",
            recaptchaRef,
        });
        if (!isReCaptchaValid) {
            return;
        }

        shareArticle({
            articleDescription: article.articleDescription,
            articleImage: article.articleImage,
            altText: article.altText,
            articleUrl: window.location.href,
            friendsName: recipientName,
            friendsEmailAddress: recipientEmail,
            yourName,
            yourEmailAddress: yourEmail,
            yourMessage,
            onSuccess: () => {
                setModalIsOpen(false);
                toasterContext.addToast({
                    body: siteMessage("TellAFriend_Success"),
                    messageType: "success",
                });
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.();
                }
            },
        });
    };

    return (
        <>
            <Link {...styles.link} onClick={shareLinkClickHandler} data-test-selector="articleShareLink">
                <StyledWrapper
                    css={css`
                        display: inline;
                    `}
                >
                    {text || translate("Email")}
                </StyledWrapper>
            </Link>
            <Modal
                {...styles.modal}
                headline={translate("Share Article")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                <GridContainer {...styles.container} data-test-selector="productShareModal">
                    <GridItem {...styles.recipientNameGridItem}>
                        <TextField
                            label={translate("Recipient Name*")}
                            value={recipientName}
                            error={recipientNameError}
                            onChange={recipientNameChangeHandler}
                            data-test-selector="productShareRecipientName"
                            {...styles.recipientNameTextField}
                            id="my-text-field"
                        />
                    </GridItem>
                    <GridItem {...styles.recipientEmailGridItem}>
                        <TextField
                            label={translate("Recipient Email*")}
                            value={recipientEmail}
                            error={recipientEmailError}
                            onChange={recipientEmailChangeHandler}
                            data-test-selector="productShareRecipientEmail"
                            {...styles.recipientEmailTextField}
                        />
                    </GridItem>
                    <GridItem {...styles.yourNameGridItem}>
                        <TextField
                            label={translate("Your Name*")}
                            value={yourName}
                            error={yourNameError}
                            onChange={yourNameChangeHandler}
                            data-test-selector="productShareYourName"
                            {...styles.yourNameTextField}
                        />
                    </GridItem>
                    <GridItem {...styles.yourEmailGridItem}>
                        <TextField
                            label={translate("Your Email*")}
                            value={yourEmail}
                            error={yourEmailError}
                            onChange={yourEmailChangeHandler}
                            data-test-selector="productShareYourEmail"
                            {...styles.yourEmailTextField}
                        />
                    </GridItem>
                    <GridItem {...styles.yourMessageGridItem}>
                        <TextArea
                            label={translate("Your Message*")}
                            value={yourMessage}
                            error={yourMessageError}
                            onChange={yourMessageChangeHandler}
                            data-test-selector="productShareYourMessage"
                            {...styles.yourMessageTextArea}
                        />
                    </GridItem>
                    <GridItem {...styles.reCaptchaGridItem}>
                        <ReCaptcha recaptchaRef={recaptchaRef} location="ShareProduct" />
                    </GridItem>
                    <GridItem {...styles.buttonWrapper}>
                        <StyledWrapper>
                            <Button
                                {...styles.shareButton}
                                onClick={shareButtonClickHandler}
                                data-test-selector="productShareSubmit"
                            >
                                {translate("SHARE")}
                            </Button>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(INTArticleShareLink);
